var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 30,
    viewBox: "0 0 40 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 26.25V3.75C40 1.675 38.4245 0 36.4727 0H3.52734C1.57554 0 0 1.675 0 3.75V26.25C0 28.325 1.57554 30 3.52734 30H36.4727C38.4245 30 40 28.325 40 26.25ZM36.9195 3.475C37.6955 4.3 37.2722 5.15 36.8489 5.575L27.3016 14.875L36.4727 25.025C36.7549 25.375 36.943 25.925 36.6138 26.3C36.3081 26.7 35.6026 26.675 35.2969 26.425L25.0206 17.1L19.9882 21.975L14.9794 17.1L4.70312 26.425C4.39741 26.675 3.69195 26.7 3.38624 26.3C3.05703 25.925 3.24515 25.375 3.52734 25.025L12.6984 14.875L3.15109 5.575C2.72781 5.15 2.30453 4.3 3.08054 3.475C3.85655 2.65 4.65608 3.05 5.31452 3.65L19.9882 16.25L34.6855 3.65C35.3439 3.05 36.1434 2.65 36.9195 3.475Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.48043924213d283a6331995fe606063d.svg";
export { ForwardRef as ReactComponent };